/**
 * vignette.js
 */

// Import
import "./vignette.scss";
import $ from 'jquery';


let vignettes = document.querySelectorAll('.rang-vignette .wp-block-column p a');

for (var i = 0; i < vignettes.length; i++) {
    document.querySelectorAll('.rang-vignette .wp-block-column p a')[i].innerHTML = vignettes[i].innerHTML.slice(0, 160);
}


/***** Récupère la hauteur du titre le plus grand pour fixer la hauteur et le padding de la vignette *****/

window.addEventListener('resize', function(event) {
  screenSizeRefresh();
}, true);


function screenSizeRefresh(){
  
  var parent = $(".rang-vignette"),
  vignette =$(".rang-vignette "),
  
  bodyWidth = $("body").outerWidth();

  //console.log("Width du body : "+bodyWidth);

  if(parent.length !== 0){
    if(bodyWidth > 764){
      parent.each(function(){
        
        var grandLienVignette = 0;
        var grandParagrapheVignette = 0;
        var lienVignette = $(this).find("h3 a");
        var paragrapheVignette = $(this).find("p");
        lienVignette.each(function(){
            
          var thisHeightA = $(this).height();
          if(thisHeightA > grandLienVignette){
            grandLienVignette = thisHeightA;
          }
    
        });
    
        paragrapheVignette.each(function(){
            var thisHeightB = $(this).height();
            if(thisHeightB > grandParagrapheVignette){
                grandParagrapheVignette = thisHeightB;
            }
          });
    
          
        var topOfP = grandLienVignette  + (1.5*25) - 6;
        var paddingVignette = grandParagrapheVignette + 25 + (1.5*25) - 6;
    
    
        $(this).find("p").css({ top: topOfP+'px' });
        $(this).find("h3 a").css({ paddingBottom: paddingVignette+'px' });
    
      });
      } else if(bodyWidth < 764 && bodyWidth > 425){
      //} else {
      parent.each(function(){
        var lienVignetteRang1 = $(this).find(".rang1 h3 a"),
            lienVignetteRang2 = $(this).find(".rang2 h3 a"),
            paragrapheRang1 = $(this).find(".rang1 p"),
            paragrapheRang2 = $(this).find(".rang2 p"),
            grandLienRang1 = 0,
            grandLienRang2 = 0,
            heightParaRang1 = 0,
            heightParaRang2 = 0,
            paddingParaRang1 = 0,
            paddingParaRang2 = 0,
            topOfPRang1 = 0,
            topOfPRang2 = 0;
            
            lienVignetteRang1.each(function(){
              var thisHeightA = $(this).height();
              if(thisHeightA > grandLienRang1 ){
                grandLienRang1 = thisHeightA;
              }
            });

            lienVignetteRang2.each(function(){
              var thisHeightB = $(this).height();
              if(thisHeightB > grandLienRang2){
                grandLienRang2 = thisHeightB;
              }
            });
    
            paragrapheRang1.each(function(){
              var thisHeightC = $(this).height();
              if(thisHeightC > heightParaRang1 ){
                heightParaRang1 = thisHeightC;
              }
            });
            
            paragrapheRang2.each(function(){
              var thisHeightD = $(this).height();
              if(thisHeightD > heightParaRang2 ){
                heightParaRang2 = thisHeightD;
              }
            });
            
              topOfPRang1 = grandLienRang1 + (1.5*25);
              topOfPRang2 = grandLienRang2 + (1.5*25);
              paddingParaRang1 = heightParaRang1 + 25 + (1.5*25);
              paddingParaRang2 = heightParaRang2 + 25 + (1.5*25);
    
              $(this).find(".rang1 p").css({ top: topOfPRang1 +'px' });
              $(this).find(".rang2 p").css({ top: topOfPRang2 +'px' });
    
              $(this).find(".rang1 h3 a").css({ paddingBottom: paddingParaRang1+'px' });
              $(this).find(".rang2 h3 a").css({ paddingBottom: paddingParaRang2+'px' });
      });
    } else {
      parent.each(function(){
          var vignette = $(this).find(".wp-block-column");
          var topOfPRang = 0;
          var linkHeight = 0;
          var textHeight = 0;

          vignette.each(function(){
            var link = $(this).find("h3 a");
            var text = $(this).find("p");

            text.each(function(){
              textHeight = $(this).height();
            });

            link.each(function(){
              linkHeight = $(this).height();      
              var test = textHeight + 7 + 50;
              $(this).css({ paddingBottom: test +'px' });
            });

            text.each(function(){
              topOfPRang = linkHeight + (1.5*25);
              $(this).css({ top: topOfPRang +'px' });
            });
          });
      });
    }
  }
}

screenSizeRefresh();



/******** Transformer les e en <sup>e</sup> */
var titre = $('#main-content h1').text();
var breadcrumb = $('#sub-header-wrapper .breadcrumb-wrapper .breadcrumb li span.breadcrumb_last').text();


var newTitre = titre.replace(/(\d)(e)(\W|$)/g, "$1<sup>$2</sup>$3");
var newBreadcrumb = breadcrumb.replace(/(\d)(e)(\W|$)/g, "$1<sup>$2</sup>$3");

$('#main-content h1').html(newTitre );
$('#sub-header-wrapper .breadcrumb-wrapper .breadcrumb li span.breadcrumb_last').html(newBreadcrumb);




/*console.log("hauteur : "+menuSecondaireHeight);
console.log("hauteur avec margin : "+menuSecondaireHeightMargin);
$( window ).onscroll(function() {
  console.log("dans le scroll");
  $( ".test-class" ).css( "top", menuSecondaireHeightMargin);
});*/